import { render, staticRenderFns } from "./CourseStudentsProgress.vue?vue&type=template&id=b8337a50&scoped=true&"
import script from "./CourseStudentsProgress.vue?vue&type=script&lang=js&"
export * from "./CourseStudentsProgress.vue?vue&type=script&lang=js&"
import style0 from "./CourseStudentsProgress.vue?vue&type=style&index=0&id=b8337a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8337a50",
  null
  
)

export default component.exports